<div class="actions-container">
  <div class="sub-item-title">Routing</div>
  <div class="sub-title">Method:</div>
  <div class="sub-item">
    <span [hidden]="item.routingMethod !== 'seq'">Sequence</span>
    <span [hidden]="item.routingMethod !== 'fork'">Forking</span>
  </div>

  <ng-container *ngIf="item.noAnswerTimeout">
    <div class="sub-title">No Answer Timeout (sec):</div>
    <div class="sub-item">
      <span>{{item.noAnswerTimeout}}</span>
    </div>
  </ng-container>


  <div class="sub-item-title">Action</div>
  <div class="actions">
    <div class="actions-content">
      <div *ngFor="let entry of item.action | keyvalue">
        <div class="actions-sub-content">
          <div class="sub-title">Priority: {{entry.key}}</div>
          <div class="sub-item">
            <div *ngFor="let action of entry.value">
              <div class="sub-item-discard" *ngIf="action.discard">
                <span style="margin-left: 3px">Discard Action </span>
                <span *ngIf="action.sipReason"><br><b>SIP Reason:</b> {{action.sipReason}} </span>
              </div>
              <div class="sub-item-registered-users" *ngIf="action.registeredUsers">
                <span style="margin-left: 3px"> Registered Users Action </span>
              </div>
              <div class="sub-item-registered-users" *ngIf="action.continueWithNodeInternalTables">
                <span style="margin-left: 3px"> Stop ARM routing and continue with node`s internal routing table </span>
              </div>
              <div class="sub-item-discard-disabled" *ngIf="!action.discard && !action.registeredUsers">
                <span *ngIf="action.loopback"><b>Loopback action</b></span>
                <span *ngIf="action.pConnection"> {{action.pConnection.name}}  </span>
                <span *ngIf="!action.pConnection && action.node"> {{action.node.name}} </span>
                <span *ngIf="action.voipPeer"> {{action.voipPeer.name}} </span>
                <span *ngIf="action.viaNodes && action.viaNodes.length > 0">via {{action.viaNodes[0].name}} </span>
                <span *ngIf="action.resourceGroup"> {{action.resourceGroup.name}} </span>

                <span *ngIf="action.srcNormGroup"><br><b>Src Man.:</b> {{action.srcNormGroup.groupName}} {{getSrcNormHeaders(action)}} </span>
                <span *ngIf="action.dstNormGroup"><br><b>Dst Man.:</b> {{action.dstNormGroup.groupName}} </span>
                <span *ngIf="action.sipManipulationGroup"><br><b>Sip Manipulation Group:</b> {{action.sipManipulationGroup.name}} </span>
                <span *ngIf="action.destTypeRequestUri"><br><b>Route based on request URI</b></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
